import {Progress} from "antd";
import className from "classnames/bind";
import style from "../style/SiteCrawler.module.scss";

const cn = className.bind(style);

/**
 * Thanh tiến độ khi crawl đang chạy (FE poll trạng thái). progress = {total, processed,
 * percent, pending, processing, done, failed}.
 */
function CrawlProgress({progress}) {

	const p = progress || {};

	return (
		<div className={cn('progressBox')}>
			<Progress
				type="circle"
				percent={p.percent || 0}
				size={140}
				strokeColor="#4f46e5"
			/>
			<div className={cn('progressLabel')}>
				Đang crawl nền… {p.processed || 0}/{p.total || 0} URL. Trang tự cập nhật mỗi 3 giây —
				bạn có thể rời trang, crawl vẫn chạy tiếp.
			</div>
			<div className={cn('counts')}>
				<span>Chờ: <strong>{p.pending || 0}</strong></span>
				<span>Đang xử lý: <strong>{p.processing || 0}</strong></span>
				<span>Xong: <strong>{p.done || 0}</strong></span>
				<span>Lỗi: <strong>{p.failed || 0}</strong></span>
			</div>
		</div>
	);
}

export default CrawlProgress;
